import { Container, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useAuthContext } from "src/auth/hooks";
import { JwtLoginView } from "src/sections/auth/custom";
import { useRouter, useSearchParams } from "src/routes/hooks";

export default function LoginPage() {
  const { authenticated } = useAuthContext();
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (authenticated) {
      const returnTo = searchParams.get("returnTo");
      window.location.href = returnTo ? decodeURIComponent(returnTo) : "/";
    }
  }, [authenticated, router, searchParams]);

  if (authenticated) return null;

  return (
    <>
      <Helmet>
        <title>{t("login")}</title>
      </Helmet>

      <Container sx={{ mt: 15 }} maxWidth="sm">
        <Typography variant="h2">{t("login")}</Typography>
        <JwtLoginView onClose={() => {}} />
      </Container>
    </>
  );
}
